// 型安全なObject操作のユーティリティ関数群

/**
 * Object.entriesの型安全版
 * 戻り値の型を[keyof T, T[keyof T]][]として保持する
 */
export function typedEntries<T extends Record<PropertyKey, unknown>>(
  obj: T,
): Array<[keyof T, T[keyof T]]> {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>;
}

/**
 * Object.keysの型安全版
 * 戻り値の型を(keyof T)[]として保持する
 */
export function typedKeys<T extends Record<PropertyKey, unknown>>(
  obj: T,
): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}

/**
 * Object.valuesの型安全版
 * 戻り値の型をT[keyof T][]として保持する
 */
export function typedValues<T extends Record<PropertyKey, unknown>>(
  obj: T,
): Array<T[keyof T]> {
  return Object.values(obj) as Array<T[keyof T]>;
}

/**
 * enum用の型安全なObject.entries
 * enumの場合、keyがstringになることを明示的に型付け
 */
export function enumEntries<T extends Record<string, string | number>>(
  enumObject: T,
): Array<[string, T[keyof T]]> {
  return Object.entries(enumObject) as Array<[string, T[keyof T]]>;
}

/**
 * as constアサーションされた定数オブジェクト用の型安全なObject.entries
 * constオブジェクトのkeyを正確に型付け
 */
export function constEntries<T extends Record<string, string>>(
  constObject: T,
): Array<[keyof T, T[keyof T]]> {
  return Object.entries(constObject) as Array<[keyof T, T[keyof T]]>;
}
